import axios from 'axios'
import React, { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import { NavDireita } from '../../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/MenuDireito/unidades.css'
import ModalCriar from '../../MenuDireito/MenuDireito-Modal/ModalCadTipoDocumento'
import Modal from '../../MenuDireito/MenuDireito-Modal/ModalEdiTipoDocumento'

function SubMenuTipoDocumento() {
  var user = authService.getCurrentUser()
  const [tipoDocumentos, setTipoDocumentos] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [modalInfo, setModalInfo] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/tipodocumento/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setTipoDocumentos(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className="displayInteract">
      {modalOpen && <Modal setOpenModal={setModalOpen} modalInfo={modalInfo} />}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>CADASTRO DE TIPOS DE DOCUMENTOS</TitlePage1>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <ModalCriar />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>Descrição</th>
              <th>Observação</th>
              <th>Status</th>
            </thead>
            <tbody>
              {tipoDocumentos
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.tpdDescricao
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()) ||
                    val.tpdObservacoes
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(tipoDocumento => (
                  <tr
                    key={tipoDocumento.IdTipoDocumento}
                    onClick={() => handleToggleComplete(tipoDocumento)}
                  >
                    <td>{tipoDocumento.tpdDescricao}</td>
                    <td>
                      <p className="Space2">{tipoDocumento.tpdObservacoes}</p>
                    </td>
                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!tipoDocumento.tpdStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default SubMenuTipoDocumento
